import { render } from "./catalog_items.vue?vue&type=template&id=0bdb301c&scoped=true"
import script from "./catalog_items.vue?vue&type=script&lang=js"
export * from "./catalog_items.vue?vue&type=script&lang=js"

import "./catalog_items.vue?vue&type=style&index=0&id=0bdb301c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bdb301c"]])

export default __exports__